<template lang="pug">
.vs-gra(v-if="localStat.i")
	.vs-gra-info
		span.vs-gra-info__lab(:class="{'vs-gra-info__lab--winner': localWinPercent }")
			AnimatedValue(:value="`${localStat.c}/${localStat.i} (${localStat.p}%)`")
		span.vs-gra-info__leg {{ $t(localStat.name) }}
		span.vs-gra-info__lab(:class="{'vs-gra-info__lab--winner': visitingWinPercent }")  
			AnimatedValue(:value="`${visitingStat.c}/${visitingStat.i} (${visitingStat.p}%)`")
	.vs-gra-sco
		.vs-gra-sco__local(:style="{'flex-grow': `${localGrowPercent}` }")
		.vs-gra-sco__line
		.vs-gra-sco__visitor(:style="{'flex-grow': `${visitingGrowPercent}` }")
.vs-gra(v-else)
	.vs-gra-info
		span.vs-gra-info__lab(:class="{'vs-gra-info__lab--winner': localWin }")
			span(v-if="localStat.t") {{ localStat.t}}
			AnimatedValue(v-else :value="localStat.c")
		span.vs-gra-info__leg {{ $t(localStat.name) }}
		span.vs-gra-info__lab(:class="{'vs-gra-info__lab--winner': visitingWin }")
			span(v-if="visitingStat.t") {{ visitingStat.t}}
			AnimatedValue(v-else :value="visitingStat.c")
	.vs-gra-sco
		.vs-gra-sco__local(:style="{'flex-grow': `${localGrow}` }")
		.vs-gra-sco__line
		.vs-gra-sco__visitor(:style="{'flex-grow': `${visitingGrow}` }")
</template>

<script>

import AnimatedValue from "@/components/subcomponents/general/AnimatedValue.vue"

export default {
	name: "VersusStat",
	props: {
		localStat: Object,
		visitingStat: Object
	},
	computed: {
		localPercent: function() {
			return Math.round(this.$props.localStat.c / this.$props.localStat.i * 100)
		},
		visitingPercent: function() {
			return Math.round(this.$props.visitingStat.c / this.$props.visitingStat.i * 100)
		},
		localGrowPercent: function() {
			return this.localPercent / 200
		},
		visitingGrowPercent: function() {
			return this.visitingPercent / 200
		},
		localWinPercent: function() {
			if (this.localPercent > this.visitingPercent) {
				return true
			} else if (this.localPercent == this.visitingPercent) {
				return this.$props.localStat.c > this.$props.visitingStat.c
			} else {
				return false
			}
		},
		visitingWinPercent: function() {
			if (this.localPercent < this.visitingPercent) {
				return true
			} else if (this.localPercent == this.visitingPercent) {
				return this.$props.localStat.c < this.$props.visitingStat.c
			} else {
				return false
			}
		},
		localWin: function() {
			return this.$props.localStat.c > this.$props.visitingStat.c
		},
		visitingWin: function() {
			return this.$props.localStat.c < this.$props.visitingStat.c
		},
		localGrow: function() {
			return this.$props.localStat.c / (this.$props.localStat.c + this.$props.visitingStat.c)
		},
		visitingGrow: function() {
			if (this.$props.visitingStat.c == 0) {
				return 0
			} else  {
				return this.$props.visitingStat.c / (this.$props.localStat.c + this.$props.visitingStat.c)
			}
		},
	},
	components: {
		AnimatedValue
	}
}

</script>